import { render } from "./SelectMonth.vue?vue&type=template&id=145ddb8a&scoped=true"
import script from "./SelectMonth.vue?vue&type=script&lang=js"
export * from "./SelectMonth.vue?vue&type=script&lang=js"

import "./SelectMonth.vue?vue&type=style&index=0&id=145ddb8a&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145ddb8a"]])

export default __exports__